import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ControlUser } from '../model/controlUser';
import { OwnerRegistrationData } from '../model/ownerRegistrationData';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';

@Component({
  selector: 'app-owner-add',
  templateUrl: './owner-add.component.html',
  styleUrls: ['./owner-add.component.css']
})
export class OwnerAddComponent implements OnInit {

  @ViewChild('owneraddloader', { static: true }) loader;

  ownerForm = new FormGroup({
    name: new FormControl(''),
    email: new FormControl(''),
    password: new FormControl(''),
    password2: new FormControl(''),
  });

  promoteUserForm = new FormGroup({
    name: new FormControl(''),
    email: new FormControl('')
  });

  nameError: boolean = false;
  emailError: boolean = false;
  password1Error: boolean = false;
  passwordsNotMatchError: boolean = false;

  nameErrorPromote: boolean = false;
  emailErrorPromote: boolean = false;

  createNewOwnerString = $localize`:@@owneradd_create_new:Crea nuovo gestore`;
  promoteOwnerString = $localize`:@@owneradd_promote_existing_owner:Promuovi utente esistente`;

  constructor(private userService: UserService, private cdRef:ChangeDetectorRef, private router: Router) {
    
  }

  ngOnInit(): void {
  }

  createOwner() {

    let ownerRegistrationData = new OwnerRegistrationData();
 
    let name = this.ownerForm.get('name').value;
    let email = this.ownerForm.get('email').value;
    let password = this.ownerForm.get('password').value;
    let password2 = this.ownerForm.get('password2').value;

    this.nameError = false;
    this.emailError = false;
    this.password1Error = false;
    this.passwordsNotMatchError = false;

    if (!name || name.length < 1) {
      this.nameError = true;
      return;
    }
    if (!email || email.length < 3) {
      this.emailError = true;  
      return false;
    }
    if (!this.isValidEmailAddress(email)) {
      this.emailError = true; 
      return false;
    }
    if (!password || password.length < 8) {
      this.password1Error = true;  
      return false;
    }
    if (!password2 || password2.length < 8) {
      this.passwordsNotMatchError = true;  
      return false;
    }
    if (password != password2) {
      this.passwordsNotMatchError = true;  
      return false;
    }

    ownerRegistrationData.name = name;
    ownerRegistrationData.email = email;
    ownerRegistrationData.password = password;

    this.loader.showLoading();
      
    this.userService.createOwner(ownerRegistrationData).subscribe(u => {

      setTimeout(() => {

        this.loader.hideLoading();
        this.cdRef.detectChanges();

        this.router.navigate(['owner/' + u.uid]);
      });
      
    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
      this.cdRef.detectChanges();
    });

  }

  promoteUser(){

    let promoteUserData = new ControlUser();
 
    let name = this.promoteUserForm.get('name').value;
    let email = this.promoteUserForm.get('email').value;

    this.nameErrorPromote = false;
    this.emailErrorPromote = false;

    if (!name || name.length < 1) {
      this.nameErrorPromote = true;
      return;
    }
    if (!email || email.length < 3) {
      this.emailErrorPromote = true;  
      return false;
    }

    if (!this.isValidEmailAddress(email)) {
      this.emailErrorPromote = true; 
      return false;
    }

    promoteUserData.displayName = name;
    promoteUserData.email = email;

    this.loader.showLoading();
      
    this.userService.promoteUser(promoteUserData, email).subscribe(user => {

      setTimeout(() => {

        this.loader.hideLoading();
        this.cdRef.detectChanges();

        this.router.navigate(['owner/' + user.uid]);
      });
      
    }, error => {

      this.loader.hideLoading();
      this.loader.showError();
      this.cdRef.detectChanges();
    });

  }

  isValidEmailAddress(emailAddress): boolean {
    var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
  }

}
